import { useEffect, useState } from "react";

/**
 * A preview of a local file as an object URL, revoked when the file changes or
 * the component goes away. `null` means no file (a closed lightbox): no URL
 * exists then. The URL is kept with its file, so the render that follows a
 * change of file never hands out the previous file's (already revoked) URL.
 *
 * Shared by the surfaces that preview a file the user picked
 * (`unify-image-lightbox`): the pending story images and the feedback dialog.
 */
export function useObjectUrl(file: File | null): string | null {
  const [preview, setPreview] = useState<{ file: File; url: string } | null>(null);
  useEffect(() => {
    if (file === null) {
      setPreview(null);
      return;
    }
    const url = URL.createObjectURL(file);
    setPreview({ file, url });
    return () => URL.revokeObjectURL(url);
  }, [file]);
  return preview !== null && preview.file === file ? preview.url : null;
}
